export const REDIRECT_URL_KEY = 'auth_redirect_url';
export const REDIRECT_URL_EXPIRY_KEY = 'auth_redirect_url_expiry';
const REDIRECT_URL_EXPIRY_DURATION = 30 * 60 * 1000; // 30 minutes expiry

export const saveRedirectUrl = (url: string) => {
  const expiryTime = Date.now() + REDIRECT_URL_EXPIRY_DURATION;
  localStorage.setItem(REDIRECT_URL_KEY, url);
  localStorage.setItem(REDIRECT_URL_EXPIRY_KEY, expiryTime.toString());
};

export const getAndClearRedirectUrl = () => {
  try {
    const url = localStorage.getItem(REDIRECT_URL_KEY);
    const expiryTime = localStorage.getItem(REDIRECT_URL_EXPIRY_KEY);

    // clear local storage regardless of expiry
    localStorage.removeItem(REDIRECT_URL_KEY);
    localStorage.removeItem(REDIRECT_URL_EXPIRY_KEY);

    // if no URL exists, return null
    if (!url) {
      return null;
    }

    // return null if the URL has expired
    if (expiryTime && Date.now() > parseInt(expiryTime)) {
      return null;
    }

    return url;
  } catch (error) {
    // if there any errors clean up and return null
    localStorage.removeItem(REDIRECT_URL_KEY);
    localStorage.removeItem(REDIRECT_URL_EXPIRY_KEY);
    return null;
  }
};
